// WAF service gating — decides when the Owl/Mlytics WAF console is offered under
// the Security category.
//
// The Owl/Mlytics service (provider scope `External.Mlytics`) opens its own
// dedicated WAF/CDN console (`/api/v3/waf`), NOT the shared Manticore CDN
// console. Although its scope is catalog-grouped under CDN, the customer-facing
// product is a Web Application Firewall, so the services dashboard surfaces it as
// a WAF card under Security (mirroring how WAAP is special-cased).
import { serviceProviderScope, type AvailableService } from '@/api/services';

/** Provider scope backing the Owl/Mlytics WAF console. */
export const WAF_SCOPE = 'External.Mlytics';

/** True when a provisioned service opens the Owl/Mlytics WAF console. */
export function isWafCapable(service: AvailableService): boolean {
  return serviceProviderScope(service) === WAF_SCOPE;
}

/** Route to a service's WAF console. */
export function wafConsoleRoute(serviceId: string): string {
  return `/services/waf/${serviceId}`;
}

/** Card metadata for a WAF service (mirrors the catalog `ServiceProduct` shape
 *  consumed by the services dashboard card). */
export const WAF_PRODUCT = {
  displayName: 'Web Application Firewall',
  description:
    'Managed DNS, Multi-CDN delivery, firewall rules, bot management and SSL/TLS — secured and accelerated for your domains.',
  features: ['Managed DNS', 'WAF Rules', 'Bot Management', 'SSL/TLS'],
} as const;
